/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/ContainsSubstringOnlyOnce.ts
 * @create:      2025-06-26 10:11:05.707
 * @modify:      2025-07-11 21:19:12.856
 * @version:     6.0.0
 * @times:       6
 * @lines:       64
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Determines whether each of the specified substrings appears exactly once in the given string.
 *
 * @param str - The string to search within.
 * @param substrings - One or more substrings to check for single occurrence in `str`.
 * @returns `true` if every substring appears exactly once in `str`, otherwise `false`.
 *
 * @example
 * ```typescript
 * ContainsSubstringOnlyOnce("hello world", "hello"); // true
 * ContainsSubstringOnlyOnce("hello hello world", "hello"); // false
 * ContainsSubstringOnlyOnce("hello world", "hello", "world"); // true
 * ContainsSubstringOnlyOnce("hello world", "hello", "foo"); // false
 * ```
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function ContainsSubstringOnlyOnce(str: string, ...substrings: string[]) {
    for (const substring of substrings) {
        if (!str.includes(substring)) {
            return false;
        }

        if (str.split(substring).length > 2) {
            return false;
        }
    }

    return true;
}
